
import Vue from "vue";
import {mapState} from 'vuex'
import {ObjectUtils} from "~/assets/utils/ObjectUtils"

export default Vue.extend({
	name: 'Sidebar',
	computed: {
		...mapState(['idgroup', 'navigation', 'domain']),
		hasMotor(): boolean {
			return Array.isArray(this.navigation?.motor) && this.navigation.motor.length > 0;
		},
		hasHome(): boolean {
			return Array.isArray(this.navigation?.home) && this.navigation.home.length > 0;
		}
	},
	data: () => ({
		loaded: false,
		isOpen: null,
		domaingroup: [],
		navmotor: {},
		navhome: {},
		groupMotor: [],
		motorPath: [],
		groupHome: [],
		homePath: []
	}),
	methods: {
		buildNav() {
			/**
			 * @author @Simo mailto:simoneolivieri@kubepartners.com
			 * @description //retrive nagivation array from store and groupby domain
			 * @date 09:53 18/04/23
			 * @param mapState(['navigation'])
			 * @return groupByKey
			 **/
			const nav = this.navigation || {};
			this.domaingroup = Object.keys(nav);

			const motorNav = Array.isArray(nav['motor']) ? nav['motor'] : [];
			const homeNav = Array.isArray(nav['home']) ? nav['home'] : [];

			this.navmotor = motorNav.length ? ObjectUtils.groupByKey(motorNav, 'idgroup') : {};
			this.navhome = homeNav.length ? ObjectUtils.groupByKey(homeNav, 'idgroup') : {};
			this.groupMotor = Object.keys(this.navmotor);
			this.groupHome = Object.keys(this.navhome);

			this.motorPath = this.groupMotor.map(group => this.navmotor[group]?.[0]?.path).filter(Boolean);
			this.homePath = this.groupHome.map(group => this.navhome[group]?.[0]?.path).filter(Boolean);
		},
		noSubnav() {

		},
		openSubnav(event) {
			const boxes = document.querySelectorAll('.mainNav')
			boxes.forEach(box => {
				if (box !== event.currentTarget) {
					box.classList.remove('isOpen')
				}
			})
			event.currentTarget.classList.toggle('isOpen')
		}
	},
	mounted() {
		this.loaded = true
		this.buildNav()
		// console.log(this.navmotor)
	}
})
